import { BREAKPOINTS } from "@/utils/config";
import { useEffect, useState } from "react";

/**
 * Hook to detect if the screen size is large (>= 1024px)
 * @param breakpoint - The pixel breakpoint to consider as large screen (default: LG breakpoint)
 * @returns boolean indicating if screen is large
 */
export const useIsLargeScreen = (breakpoint: number = BREAKPOINTS.LG): boolean => {
    const [isLargeScreen, setIsLargeScreen] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsLargeScreen(window.innerWidth >= breakpoint);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, [breakpoint]);

    return isLargeScreen;
}; 